"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasContextOperand = hasContextOperand;
exports.isWellFormedContextFilter = isWellFormedContextFilter;
// The form holds a list operand bare; the wire wraps it as `{ values }`.

const isRecord = value => typeof value === 'object' && value !== null && !Array.isArray(value);
function hasContextOperand(operand) {
  if (Array.isArray(operand)) {
    return operand.length > 0;
  }
  if (isRecord(operand)) {
    const {
      values
    } = operand;
    return Array.isArray(values) && values.length > 0;
  }
  return operand !== undefined && operand !== null && operand !== '';
}
function isCompletePredicate(value) {
  if (!isRecord(value)) {
    return false;
  }
  const operators = Object.keys(value).filter(key => key !== 'not');
  return operators.length === 1 && hasContextOperand(value[operators[0]]);
}
function isWellFormedContextFilter(contextFilter) {
  if (contextFilter == null) {
    return true;
  }
  const {
    conjunctions
  } = contextFilter;
  if (!Array.isArray(conjunctions) || conjunctions.length === 0) {
    return false;
  }
  return conjunctions.every(({
    clauses
  }) => {
    if (!Array.isArray(clauses) || clauses.length === 0) {
      return false;
    }
    return clauses.every(({
      predicates
    }) => {
      if (!isRecord(predicates)) {
        return false;
      }
      const rows = Object.values(predicates);
      return rows.length > 0 && rows.every(isCompletePredicate);
    });
  });
}